type TModalableJQuery = JQueryStatic & {
    modalable: (method: 'open', options: { url: string }) => void;
};

export const openTariffPayment = (url: string) => {
    const legacyJQuery = $ as TModalableJQuery;

    if (typeof legacyJQuery.modalable !== 'function') {
        throw new Error('Legacy modalable is not available');
    }

    legacyJQuery.modalable('open', { url });
};
